<template>
    <v-row class="mt-2">
        <v-col cols="3">
            <v-treeview
                :items="sections"
                :itemOpen.sync="itemOpen"
                :active.sync="activeNodes"
                :open.sync="openNodes"
                expand-icon=""
                color="primary-light"
                activatable
                :calculate-width="true"
                :open-all="true"
                class="style-tree scroll-y"
                @update:active="previewItem(activeNodes[0]); openNodes.push($event.id)"
                :loading="loading"
                :style="{ 'height': `${$vuetify.breakpoint.height - 90}px` }"
                @change="getParent()"
            >
                <template v-slot:prepend="{ item, open }">
                    <v-icon
                        v-if="item.children && item.children.length"
                        class="mx-0"
                        @click="(() => {
                            if(open) {
                                openNodes.splice(openNodes.indexOf(item.id), 1)
                            } else{ 
                                openNodes.push(item.id)
                            }

                        })"
                    >   
                        {{open ? 'mdi-minus' : 'mdi-plus'}}
                    </v-icon>
                </template>
            </v-treeview>
        </v-col>

        <v-col v-if="$route.params.id && $route.params.parent" cols="9">
            <bee-handy-table
                
                :headers="headers"
                :items="items"
                dense
                zebra
                hide-default-footer
                :items-per-page="-1"
                :height="$vuetify.breakpoint.height - 90"
                table-class="rounded-lg"
                fixed-header
            >
                <template v-slot:item.booleanValue="{ item }">
                    <div class="d-flex">
                        <v-switch
                            v-model="item.booleanValue" 
                            hide-details
                            class="mt-0"
                        ></v-switch>
                    </div>
                </template>
            </bee-handy-table>
        </v-col>

        <v-col
            v-else
            cols="9"
            class="d-flex flex-column justify-center align-center"
            :style="{ height: `${$vuetify.breakpoint.height - 90}px` }"
        >
            <v-progress-circular
                v-if="loading"
                color="primary"
                indeterminate
                size="44"
                width="4"
            />
            <template v-else>
                <v-icon size="60" class="mb-1">mdi-account-cog</v-icon>
                <span class="text-h6">{{$t('Settings.please-select-a-section')}}</span>
            </template>
        </v-col>
    </v-row>
</template>

<script>
import { mapState } from 'vuex'
export default {
    data () {
        return {
            // centerNotes 3
            // doctorNames 18
            key: 0,
            section: 0,

            customerType: null,

            itemsStaff: [
                {
                    name: this.$t('Settings.phone-number'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.landline-number'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.address'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.email'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.job-position'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.facebook-profile-url'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.starting-date'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.line-manager'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.role'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.gender'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.regions'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.specialty'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.team'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.leave-days-number'),
                    permissionEnum: 0,
                    booleanValue: null
                 
                },
                {
                    name: this.$t('Settings.username'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.password'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.certificate'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.target-value'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.financial-target-value'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.employee-type'),
                    permissionEnum: 0,
                    booleanValue: null
                }

            ],

            itemsStaffRole : [
                {
                    name: this.$t('Settings.leaves'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.add-leaves-for-staff'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.manage-leave-balances'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.generate-materials'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.material-transactions'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.rep-plan'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.rep-visits'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.weekly-reports'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.monthly-plan-reports'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                 {
                    name: this.$t('Settings.reviews'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.exams'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.salaries'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.rep'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.entities'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                 {
                    name: this.$t('Settings.entity-modification-requests'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.charts'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.regions'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.users'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.roles'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.general-filter'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.manage-team'),
                    permissionEnum: 0,
                    booleanValue: null
                }
            ],
            //   "": [
            //     {
            //       "address": "string",
            //       "regionId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            //       "workloadId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            //       "visitTime": "string",
            //       "bestTimeToVisit": "string",
            //       "longitude": "string",
            //       "latitude": "string"
            //     }
            //   ],
            itemsCustomers: [
                {
                    name: this.$t('Settings.name'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.type'),
                    permissionEnum: 0,
                    booleanValue: null
                },

                {
                    name: this.$t('Settings.entity-type'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.specialty'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.best-time-to-visit'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.opening-time'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.closing-time'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.resident-doctor-names'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.contact-info'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.address'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.loyalty'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.religion'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.personality'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.birthdate'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.weekend'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.personal-note'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.doctor-hobbies'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.near-by-pharmacies'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.visit-notes'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.works-in-centers'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.pharmacist-info'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.work-hours-to'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.work-hours-from'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.pharmacy-info'),
                    permissionEnum: 0,
                    booleanValue: null
                }
            ],

            itemsVisits: [
                {
                    name: this.$t('Settings.entity'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.free-sample'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.other-samples'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.notes'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.objections'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.next-visit-notes'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.purpose'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.material-amounts'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.unavailable-material'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.competitive-samples'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.core-message'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.longitude'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.latitude'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.duration-in-minutes'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.amount-received'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.resident-doctor-names'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.payment'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.price-type'),
                    permissionEnum: 0,
                    booleanValue: null
                }
            ],

            itemsMaterials: [
                {
                    name: this.$t('Settings.number'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                  {
                    name: this.$t('Settings.name'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                  {
                    name: this.$t('Settings.material-form'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                  {
                    name: this.$t('Settings.description'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.dose'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.strength'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.pills-per-box'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.price'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.leaflet-file-path'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.specialty'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.min-amount'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.max-amount'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.composition-per-unit'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.pharmacies-price'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.price-types'),
                    permissionEnum: 0,
                    booleanValue: null
                },
                {
                    name: this.$t('Settings.price-discount-rate'),
                    permissionEnum: 0,
                    booleanValue: null
                }
            ],
            itemsCustomersType: [],
            // items: [
            //     {
            //         name: this.$t('Settings.loyalty'),
            //         permissionEnum: 0,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.religion'),
            //         permissionEnum: 1,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.personality'),
            //         permissionEnum: 2,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.birthdate-client'),
            //         permissionEnum: 3,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.weekend'),
            //         permissionEnum: 4,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.near-by-pharmacies'),
            //         permissionEnum: 5,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.near-by-pharmacies-two'),
            //         permissionEnum: 6,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.works-in-centers'),
            //         permissionEnum: 7,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.work-hour-from'),
            //         permissionEnum: 8,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.work-hour-to'),
            //         permissionEnum: 9,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.doctor-hobbies'),
            //         permissionEnum: 10,
            //         booleanValue: null
            //     },
            //     {
            //         name: this.$t('Settings.visit-notes'),
            //         permissionEnum: 11,
            //         booleanValue: null
            //     }
            // ],

            itemsFromApi: [
                {
                    key: 'cda06b59-e5b7-4c26-6d64-08ddb946469b',
                    field: '1,3,4,5,7,8,9,10,11,12' 
                },
                {
                    key: 'ecfe07fe-8af1-47c9-6d65-08ddb946469b',
                    field: '1,2,3,4,5,6,7,8,10,11,12' 
                }
            ],
            itemOpen: 10000,
			activeNodes: [0],
			openNodes: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            loading: false,
            sectionsFlat: [],
            parent: null,
            items: []
        }
    },

    watch: {
        '$route.params.id'(val) {
            if (val) {
                switch (this.$route.params.parent) {
                    case 'Staff':
                        this.items = this.itemsStaffRole;
                        break;
                    case 'ParentCustomers':
                        this.items = this.itemsCustomers;
                        break;
                    case 'ParentStaff':
                        this.items = this.itemsStaff;
                        break;
                    case 'Customers':
                        this.items = this.itemsCustomersType;
                        break;
                    case 'ParentVisits':
                        this.items = this.itemsVisits;
                        break;
                    case 'ParentMaterials':
                        this.items = this.itemsMaterials;
                        break;
                    default:
                    this.items = []; // يمكنك إضافة هذا الخيار إذا كنت تريد تعيين items إلى مصفوفة فارغة في حال عدم تطابق أي حالة.
                }
            } else {
                this.items = []
            }
        }
        // customerType (val) {
           
        // }
    },
	computed: {
		...mapState({
			customersTypes: state => state.entityType.customersTypes,
            permissionArray: state => state.entityType.permissionArray,
            userLoginEmployeeId: state => state.auth.self.employeeId,
            roles: state => state.rolePermission.roles
		}),

        headers () {
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'name',
                    value: 'name',
                    width: '65%'
                },
                {
                    text: this.$t('headers.actions'),
                    name: 'booleanValue',
                    value: 'booleanValue',
                    columnClass: 'text-center'
                }
            ]
        },

        sections () {
            return [
                {
                    name: 'Staff',
                    id: 11,
                    children: this.roles.map(c => ({ ...c, parentId: 0, parent: 'Staff' })),
                    parent: 'ParentStaff'
                },
                {
                    name: 'Customers',
                    id: 1,
                    children: this.customersTypes.map(c => ({ ...c, parentId: 1, parent: 'Customers' })),
                    parent: 'ParentCustomers' 
                },
                {
                    name: 'Materials',
                    id: 2,
                    children: [],
                    parent: 'ParentMaterials' 
                },
                {
                    name: 'Visits',
                    id: 3,
                    children: [],
                    parent: 'ParentVisits'
                }
            ]
        }
        
	},

    methods: {
        resetTable () {},
        previewItem (id) {
            this.$router.replace({
                params: {
                    id: id,
                    parent: this.sectionsFlat?.find(c => c.id === id)?.parent
                }
            })
             
            const getCustomerType = this.itemsFromApi?.find(c => c.key === this.$route.params.id)
            const permissionArray = getCustomerType?.field.split(',')

            for (let i = 0; i < this.items.length; i++) {
                const number = this.items.indexOf(this.items[i]) + 1
                if (permissionArray?.find(c => +c === number)) {
                    this.items[i].booleanValue = true
                } else {
                    this.items[i].booleanValue = false
                }
            }
        },
        flattenRoles(tree) {
            this.flatArray = [];
            for (const item of tree) {
                this.flatArray.push(item);
                if (item.children && item.children.length > 0) {
                    this.flatArray = this.flatArray.concat(this.flattenRoles(item.children));
                }
            }
            return this.flatArray;
        },
    },

    created () {
        this.loading = true
        Promise.all([
            this.$store.dispatch('rolePermission/fetchChildrenRole', { 
                id: this.userLoginEmployeeId
            }),
            !this.customersTypes.length ? this.$store.dispatch('entityType/fetchAll').then(() => {
                // this.customerType = this.customersTypes[0].id
            }) : null
        ]).then(() => {
            this.sectionsFlat = this.flattenRoles(this.sections)
            console.log(this.sectionsFlat)
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>

<style lang="scss">
@import url('../../scss/variables.scss');
.scroll-y {
    overflow-y: auto
}
.style-tree {
    background: #118aa825;
    border-radius: 10px;
}
</style>
